import { create } from 'zustand';

import type { Place } from '0_canvas/Tiles/geo';
import type { TileDefinition } from '0_canvas/Tiles/loader';

interface TilesState {
  place: Place | null;
  tileDefinitions: TileDefinition[];
  attribution: string[] | null;
  setPlace: (place: Place | null) => void;
  setTileDefinitions: (tdefs: TileDefinition[]) => void;
  setAttribution: (attr: string[]) => void;
}

const useTilesStore = create<TilesState>(set => ({
  place: null,
  tileDefinitions: [],
  attribution: null,
  setPlace: place => set({ place }),
  setTileDefinitions: tdefs => set({ tileDefinitions: tdefs }),
  setAttribution: attr => set({ attribution: attr }),
}));

export default useTilesStore;
